module.exports = __webpack_public_path__ + "img/color-2@2x.f8efcec.png";